import React, { useEffect, useState } from 'react';

import moment from 'moment';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import useAutomationTranslations from '../../utils/use-automation-translations';
import { fetchUser } from 'bringg-web/services/users';
import useDateFormat from 'bringg-web/hooks/use-date-format';

import styles from '../workflow-card/components/summary-info/summary-info.module.scss';

const MISSING_VALUE = '-';

interface Props {
	updatedAt?: string;
	updatedByUserId?: number;
}

const UnreadableWorkflowSummary = ({ updatedAt, updatedByUserId }: Props) => {
	const dateFormat = useDateFormat();
	const { updatedBy, updated } = useAutomationTranslations();
	const [userName, setUserName] = useState<string>();

	useEffect(() => {
		if (!updatedByUserId) {
			return undefined;
		}

		let userChangedOrUnmounted = false;

		const fetchUpdatedBy = async () => {
			const user = await fetchUser(updatedByUserId);

			if (!userChangedOrUnmounted) {
				setUserName(user?.name);
			}
		};

		void fetchUpdatedBy();

		return () => {
			userChangedOrUnmounted = true;
		};
	}, [updatedByUserId]);

	return (
		<div className={styles.createSummary} data-test-id="unreadable-workflow-summary">
			<span className={styles.summaryInfo}>
				{updatedBy}:{' '}
				<span className={styles.infoName} data-test-id="unreadable-workflow-updated-by">
					{updatedByUserId ? userName || 'Bringg' : MISSING_VALUE}
				</span>
			</span>
			<BringgIcon iconName={BringgFontIcons.SmallCircle} />
			<span className={styles.summaryInfo}>
				{updated}:{' '}
				<span className={styles.infoDate} data-test-id="unreadable-workflow-updated-at">
					{updatedAt ? moment(updatedAt).format(dateFormat) : MISSING_VALUE}
				</span>
			</span>
		</div>
	);
};

export default UnreadableWorkflowSummary;
